module.exports = __webpack_public_path__ + "static/media/smallPersonHidden.d91907ac.png";